import React from 'react';
import { WHATS_INCLUDED } from '../lib/content';
import { Reveal } from './Reveal';
const CARD_COLORS = [{
  bg: 'bg-[#F4F5FF]',
  border: 'border-l-[#5D5FEF]'
}, {
  bg: 'bg-[#FFF5ED]',
  border: 'border-l-[#FF8C22]'
}, {
  bg: 'bg-[#EBF7ED]',
  border: 'border-l-[#34C759]'
}];
export function WhatsIncluded() {
  return <section id="contenido" className="w-full bg-gradient-to-b from-[#FFF5ED] via-white to-white py-16 sm:py-24" data-id="element-588" data-mp="26mozjc61a69">
      <div className="mx-auto w-full max-w-2xl px-5 sm:px-8" data-id="element-589" data-mp="pvxgsbbjfu89">
        <Reveal data-id="element-590" data-mp="uuqwmaearxbl">
          <div className="relative text-center" data-id="element-591" data-mp="ut7f6ggwng88">
            {/* Decorative Stars */}
            <div className="absolute left-0 top-6 text-xl opacity-60" aria-hidden="true" data-id="element-592" data-mp="gvix1ge82n6v">✨</div>
            <div className="absolute right-0 top-12 text-2xl opacity-80" aria-hidden="true" data-id="element-593" data-mp="lt14f2clcucr">⭐</div>

            <span className="inline-flex items-center gap-1.5 rounded-full bg-white px-4 py-1.5 font-display text-[10px] font-black uppercase tracking-widest text-[#FF6B35] shadow-sm sm:text-xs" data-id="element-594" data-mp="31koymq0808rv">
              {WHATS_INCLUDED.badge}
            </span>
            
            <h2 className="mt-6 font-display text-4xl font-black leading-[1.1] sm:text-6xl" data-id="element-595" data-mp="1rilz1wugg9bq">
              <span className="block text-[#1C3587]" data-id="element-596" data-mp="1rkyqd0m3rw1g">{WHATS_INCLUDED.title}</span>
              <span className="block text-[#5D5FEF] font-sans" data-id="element-597" data-mp="26ds5gkxgqa5l">{WHATS_INCLUDED.titleHighlight}</span>
            </h2>
            
            <p className="mx-auto mt-4 max-w-sm font-display text-[15px] font-bold leading-snug text-[#4A5568] sm:text-lg" data-id="element-598" data-mp="2fg9t93srnaup">
              {WHATS_INCLUDED.description}
            </p>
          </div>

          <div className="mt-10 flex flex-col gap-4" data-id="element-599" data-mp="2p634g3ozxnyf">
            {WHATS_INCLUDED.items.map((item, i) => {
            const colorStyle = CARD_COLORS[i % CARD_COLORS.length];
            return <Reveal key={i} delay={i * 0.1} float={true} data-id="element-600" data-mp="2y6rgisutxe8o" data-mpi={i}>
                  <div className={`relative flex items-center gap-4 rounded-2xl border-l-[6px] p-5 shadow-[0_4px_20px_rgba(0,0,0,0.04)] ${colorStyle.bg} ${colorStyle.border}`} data-id="element-601" data-mp="2y4ya9eo4ow17">
                    
                    <div className="absolute right-4 top-4 rounded-full bg-white px-2.5 py-1 font-display text-[8px] font-black uppercase tracking-widest text-[#1C3587] shadow-sm" data-id="element-602" data-mp="316j8dx0fbvpc">
                      {item.label}
                    </div>

                    <span className="flex h-14 w-14 flex-none items-center justify-center rounded-2xl bg-white text-3xl shadow-sm" aria-hidden="true" data-id="element-603" data-mp="3fy1yinmzz6mf">
                      {item.emoji}
                    </span>
                    
                    <div className="flex-1 pr-16 text-left" data-id="element-604" data-mp="3owx6o59lqqsd">
                      <h3 className="font-display text-[16px] font-black leading-tight text-[#1C3587] sm:text-xl" data-id="element-605" data-mp="3twruu11zt29q">
                        {item.title}
                      </h3>
                      <p className="mt-1 text-[12px] font-bold leading-snug text-[#4A5568] sm:text-sm" data-id="element-606" data-mp="1zja3s42dpn9y">
                        {item.description}
                      </p>
                    </div>
                  </div>
                </Reveal>;
          })}

            <Reveal delay={0.3} float={true} data-id="element-607" data-mp="lojvnwovb7i7">
              <div className="relative mt-2 flex items-center gap-4 rounded-2xl border border-[#FF8C22] bg-gradient-to-r from-[#FFF9F0] to-[#FFF0E0] p-5 shadow-sm" data-id="element-608" data-mp="gw0g4u6me2ar">
                
                <div className="absolute -top-3 right-4 rounded-full bg-gradient-to-r from-[#FF8C22] to-[#FF6B35] px-3 py-1 font-display text-[9px] font-black uppercase tracking-widest text-white shadow-md" data-id="element-609" data-mp="7vu4zeye9eer">
                  {WHATS_INCLUDED.bonusTitle}
                </div>

                <span className="flex h-14 w-14 flex-none items-center justify-center rounded-2xl bg-white text-3xl shadow-sm" aria-hidden="true" data-id="element-610" data-mp="10iewcfevdqib">
                  🎁
                </span>
                
                <div className="flex-1 text-left" data-id="element-611" data-mp="qopohg6vj01v">
                  <h4 className="font-display text-[9px] font-black uppercase tracking-widest text-[#5D5FEF]" data-id="element-612" data-mp="3gcp36h48yami">
                    Y ESTO NO ES TODO...
                  </h4>
                  <h3 className="mt-0.5 font-display text-[16px] font-black leading-tight text-[#1C3587] sm:text-xl" data-id="element-613" data-mp="133cne1mawq77">
                    {WHATS_INCLUDED.bonusSubtitle}
                  </h3>
                  <p className="mt-1 text-[12px] font-bold leading-snug text-[#4A5568] sm:text-sm" data-id="element-614" data-mp="u3g3edauwfih">
                    {WHATS_INCLUDED.bonusDescription}
                  </p>
                </div>
              </div>
            </Reveal>
          </div>
        </Reveal>
      </div>
    </section>;
}